// TODO: Need refactoring (maybe use decorator)
import { PLAN_DESIGN_FIELDS_CHANGE_STATE } from "./mutations.type";

const state = {
  showPlanDesignsMiniTable: true
};

function fromPercent(value) {
  return Math.round(value * 10000) / 100;
}

function ageRequirement(design, yearsField, monthField, shortForm = false) {
  if (
    (!design[yearsField] && !design[monthField]) ||
    isSameAsAgeEE(design, yearsField, monthField)
  )
    return "Immediate";
  let data;
  if (shortForm) {
    data = 0;
    if (design[yearsField]) data += design[yearsField];
    if (design[monthField])
      data += Math.round((design[monthField] / 12) * 100) / 100;
  } else {
    data = "";
    if (design[yearsField])
      data += shortForm ? design[yearsField] : design[yearsField] + " Yrs ";
    if (design[monthField])
      data += shortForm
        ? Math.round((design[monthField] / 12) * 100) / 100
        : design[monthField] + " Mos";
  }
  return data;
}

function serviceRequirement(design, monthField) {
  if (!design[monthField] || isSameAsServiceEE(design, monthField))
    return "Immediate";
  return design[monthField] + " Mos";
}

function isSameAsAgeEE(design, yearsField, monthField) {
  return (
    yearsField !== "age_requirement_years" &&
    design.age_requirement_years === design[yearsField] &&
    design.age_requirement_months === design[monthField]
  );
}

function isSameAsServiceEE(design, monthField) {
  return (
    monthField !== "service_requirement_measurement_number" &&
    design.service_requirement_measurement_number === design[monthField]
  );
}

// ########### EMPLOYER MATCH HELPERS
function employerMatchValue(design, value) {
  return design.employer_match_contribution_type === 1
    ? `${fromPercent(value)}%`
    : `$${value}`;
}
function employerMatchTierLabel(design, tier, index) {
  if (design.employer_match_yos_vary_ee === "yes") return `EE YOS ${index}`;
  if (design.match_contrib_based_yos_yesno === 1)
    return `PYE ${tier.applicable_year}`;
  return `Tier ${index + 1}`;
}

function isDeferralRate(design) {
  return design.employer_match_contribution_type === 1;
}

function employerMatchDollarMaximum(design) {
  if (!isDeferralRate(design)) return "";
  return design.employer_match_dollar_maximum === 1
    ? `, $${design.match_dollar_limit_amount} Max`
    : "";
}

function employerMatchYOSOrYearTOYear(design, matchOnText, dollarMaximum) {
  if (design.match_contrib_based_yos_yesno === 1)
    return "Stretch Match" + dollarMaximum;
  if (design.employer_match_yos_vary_ee === "yes")
    return "Based on EE YOS" + dollarMaximum;
  return matchOnText + dollarMaximum;
}

function employerMatchCatchUp(design) {
  return design.match_on_catch_up_contributions_yesno === 1
    ? "Catch Up: Yes"
    : "Catch Up: No";
}
function employerMatchTrueUp(design) {
  return design.employer_match_true_up === "yes"
    ? "True Up: Yes"
    : "True Up: No";
}
function radioFields(value1, value2, repeatNumber) {
  let space = "&nbsp;".repeat(repeatNumber);
  return `${value1}${space}${value2}`;
}

function employerMatchCatchUpTrueUp(design) {
  return radioFields(
    employerMatchCatchUp(design),
    employerMatchTrueUp(design),
    6
  );
}
function employerMatchEOYReqt(design) {
  return design.match_require_last_day === 1 ? "EOY: Yes" : "EOY: No";
}
function employerMatchHoursReqt(design) {
  if (design.employer_match_annual_service_reqt === 1)
    return `Svc: ${design.match_hours_requirement} Mos`;
  if (design.employer_match_annual_service_reqt === 2)
    return `Svc: ${design.match_hours_requirement} Hrs`;
  return "Svc: None";
}
function employerMatchEOYHours(design) {
  let repeatNumber =
    employerMatchCatchUp(design).length - employerMatchEOYReqt(design).length;
  return radioFields(
    employerMatchEOYReqt(design),
    employerMatchHoursReqt(design),
    repeatNumber + 12
  );
}
function employerMatchVesting(design) {
  if (design.percent_match_vesting_immediate === 0) return "Immediate";
  let number = [1, 2, 3, 4, 5, 6].find(
    num => design[`percent_match_vesting_${num}_year`] === 1
  );
  if (number === undefined) return "Immediate";
  return number === 1 ||
    (number < 4 && design[`percent_match_vesting_${number - 1}_year`] === 0)
    ? `${number} Year Cliff`
    : `${number} Year Graded`;
}
function employerOtherVesting(design) {
  if (design.employer_other_vesting_immediate === 0) return "Immediate";
  let number = [1, 2, 3, 4, 5, 6].find(
    num => design[`percent_profit_sharing_vesting_${num}_year`] === 1
  );
  if (number === undefined) return "Immediate";
  return number === 1 ||
    (number < 4 &&
      design[`percent_profit_sharing_vesting_${number - 1}_year`] === 0)
    ? `${number} Year Cliff`
    : `${number} Year Graded`;
}
function employerOtherEOYReqt(design) {
  return design.profit_sharing_basic_require_last_day === 1
    ? "EOY: Yes"
    : "EOY: No";
}
function employerOtherHoursReqt(design) {
  if (design.employer_other_annual_service_reqt === 1)
    return `Svc: ${design.employer_other_annual_service_reqt_amount} Mos`;
  if (design.employer_other_annual_service_reqt === 2)
    return `Svc: ${design.employer_other_annual_service_reqt_amount} Hrs`;
  return "Svc: None";
}
function employerOtherEOYHours(design) {
  let repeatNumber =
    employerMatchCatchUp(design).length - employerMatchEOYReqt(design).length;
  return radioFields(
    employerOtherEOYReqt(design),
    employerOtherHoursReqt(design),
    repeatNumber + 12
  );
}
const getters = {
  showPlanDesignsMiniTable(state) {
    return state.showPlanDesignsMiniTable;
  },
  ageRequirement() {
    return function(design) {
      return ageRequirement(
        design,
        "age_requirement_years",
        "age_requirement_months"
      );
    };
  },
  serviceRequirement() {
    return function(design) {
      return serviceRequirement(
        design,
        "service_requirement_measurement_number"
      );
    };
  },
  autoEnrollment() {
    return function(design) {
      let contributionType = design.auto_enroll_type === 1 ? "Pre-Tax" : "Roth";
      switch (design.employee_contrib_plan_uses_autoenroll_picklist_id) {
        case 0:
          return "Not Offered";
        case 1:
          return (
            `New Hires ${contributionType} @ ` +
            fromPercent(design.initial_deferral_rate_autoenroll) +
            "%"
          );
        case 2:
          return (
            `All Employees ${contributionType} @ ` +
            fromPercent(design.initial_deferral_rate_autoenroll) +
            "%"
          );
      }
    };
  },
  autoEscalation() {
    return function(design) {
      if (design.auto_increase_available === 0) return "Not Offered";
      if (design.auto_increase_available === 1) return "Voluntary";
      return (
        "Mandatory " +
        fromPercent(design.auto_increase_annual_increase) +
        "% to " +
        fromPercent(design.auto_increase_maximum) +
        "%"
      );
    };
  },
  employerMatch() {
    return function(design) {
      if (design.plan_has_employer_matching_contributions_picklist_id === 0)
        return "None";
      let ARText = ageRequirement(
        design,
        "age_requirement_match_years",
        "age_requirement_match_months",
        true
      );
      let SRText = serviceRequirement(
        design,
        "service_requirement_match_measurement_number"
      );
      let text = ARText === "Immediate" ? "" : `Age ${ARText}`;
      text +=
        SRText === "Immediate"
          ? ""
          : `${
              text ? "&nbsp;".repeat((11 - text.length) * 2 + 10) : ""
            }Svc ${SRText}`;
      text += text ? "<br>" : "Same as EE Contributions<br>";
      let from = 0;
      let to = 0;
      let field = isDeferralRate(design)
        ? "deferral_rate"
        : "contribution_amount";
      design.tiers.forEach(tier => {
        from += +tier["matching_amount"] * +tier[field];
        to += +tier[field];
      });
      let matchOnText = `${employerMatchValue(
        design,
        from
      )} on ${employerMatchValue(design, to)}`;
      let dollarMaximum = employerMatchDollarMaximum(design);
      text += employerMatchYOSOrYearTOYear(design, matchOnText, dollarMaximum);
      text += `<br>${employerMatchCatchUpTrueUp(design)}`;
      text += `<br>${employerMatchEOYHours(design)}`;
      text += `<br>${employerMatchVesting(design)}`;
      return text;
    };
  },
  employerMatchTooltip() {
    return function(design) {
      if (design.plan_has_employer_matching_contributions_picklist_id === 0)
        return false;
      let field = isDeferralRate(design)
        ? "deferral_rate"
        : "contribution_amount";
      let text = "";
      design.tiers.forEach((tier, index) => {
        text += `${employerMatchTierLabel(design, tier, index)} - ${fromPercent(
          +tier["matching_amount"]
        )}% on ${employerMatchValue(design, +tier[field])}<br>`;
      });
      return text;
    };
  },
  employerOther() {
    return function(design) {
      let ARText = ageRequirement(
        design,
        "age_requirement_profit_sharing_years",
        "age_requirement_profit_sharing_months",
        true
      );
      let SRText = serviceRequirement(
        design,
        "service_requirement_profit_sharing_measurement_number"
      );
      let text = ARText === "Immediate" ? "" : `Age ${ARText}`;
      text +=
        SRText === "Immediate"
          ? ""
          : `${
              text ? "&nbsp;".repeat((12 - text.length) * 3 + 4) : ""
            }Svc ${SRText}`;
      text += text ? "<br>" : "Same as EE Contributions<br>";

      switch (design.profit_sharing_allocation_method) {
        case 1:
          if (
            design.employer_other_dollar_maximum === 0 ||
            design.employer_other_dollar_maximum === void 0
          ) {
            text += fromPercent(design.profit_sharing_amount_percent) + "%";
          } else {
            text +=
              fromPercent(design.profit_sharing_amount_percent) +
              "% - Max of $" +
              design.employer_other_dollar_maximum_amount;
          }
          break;
        case 2:
          text += "$" + design.employer_other_flat_dollar_amount;
          break;
        case 3:
          text +=
            fromPercent(design.employer_other_integrated_base_percent_below) +
            "% up to $" +
            design.employer_other_integrated_wage_base +
            ", " +
            fromPercent(design.employer_other_integrated_base_percent_above) +
            "% over";
          break;
      }
      text += `<br>${employerOtherEOYHours(design)}`;
      text += `<br>${employerOtherVesting(design)}`;
      return text !== "" ? text : "None";
    };
  }
};

const mutations = {
  [PLAN_DESIGN_FIELDS_CHANGE_STATE](state) {
    state.showPlanDesignsMiniTable = !state.showPlanDesignsMiniTable;
  }
};

export default {
  state,
  getters,
  mutations
};
